import { IAssetDTO, IPaginationDTO } from '@/dtos';
import axios from '@/services/axiosInterceptor';
import { AxiosHeaders, AxiosRequestConfig } from 'axios';
export interface UploadResponse {
  url: string;
  assetId: string;
}
export const MULTIPARTHEADER = new AxiosHeaders({ 'Content-Type': 'multipart/form-data' });

export const get = <T>(url: string): Promise<T> => {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        if (response && response.status === 200) {
          resolve(response.data);
        } else {
          console.log(response);
          reject(response);
        }
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject(error.request);
        } else {
          reject(error);
        }
      });
  });
};

export const post = <T>(
  url: string,
  body?: unknown,
  headers?: AxiosHeaders,
  config?: AxiosRequestConfig,
): Promise<T> => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, body, { headers, ...config })
      .then((response) => {
        // Check if response status is 200
        if (response && response.status === 200) {
          resolve(response.data);
        } else {
          // If it's not 200, handle the error
          reject(false);
        }
      })
      .catch(function (error) {
        if (error.status && error.status == 409) {
          reject(error.status);
        } else if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject(error.request);
        } else {
          reject(false);
        }
      });
  });
};

export const remove = <T>(url: string): Promise<T> => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url)
      .then((response) => {
        if (response && response.status === 200) {
          resolve(response.data);
        } else {
          // If it's not 200, handle the error
          console.log(response);
          reject(response);
        }
      })
      .catch(function (error) {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject(error.request);
        } else {
          reject(error);
        }
      });
  });
};

export const generatePagination = (pageOptions: IPaginationDTO) => {
  let urlQueryParms = [];
  if (pageOptions) {
    if (pageOptions.skip) {
      urlQueryParms.push(`skip=${pageOptions.skip}`);
    }
    if (pageOptions.limit) {
      urlQueryParms.push(`limit=${pageOptions.limit}`);
    }
    if (pageOptions.q) {
      const searchString = encodeURIComponent(pageOptions.q.trim());
      urlQueryParms.push(`q=${searchString}`);
    }
    if (pageOptions.exclude) {
      const encodedExclude = encodeURIComponent(JSON.stringify(pageOptions.exclude));
      urlQueryParms.push(`exclude=${encodedExclude}`);
    }
    if (pageOptions.orderBy) {
      const encodedSortBy = encodeURIComponent(JSON.stringify(pageOptions.orderBy));
      urlQueryParms.push(`orderBy=${encodedSortBy}`);
    }

    if (pageOptions.orderDirection) {
      urlQueryParms.push(`orderDirection=${pageOptions.orderDirection}`);
    }

    if (urlQueryParms.length > 0) {
      return '?' + urlQueryParms.join('&');
    } else {
      return '';
    }
  } else {
    return '';
  }
};

export const uploadS3 = async (
  url: string,
  file: File | Blob,
  assetId: string,
  onProgress?: (percentComplete: number) => void,
): Promise<IAssetDTO> => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    // Track upload progress
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        if (onProgress) {
          onProgress(percentComplete); // Pass progress to callback
        }
      }
    };

    xhr.open('PUT', url, true);
    xhr.setRequestHeader('Content-Type', file.type);

    // Handle the upload completion
    xhr.onload = async () => {
      if (xhr.status === 200) {
        try {
          const returnObj = await post<IAssetDTO>(`/asset/${assetId}/upload/success`);
          resolve(returnObj); // Resolve on success
        } catch {
          reject(new Error('Error updating upload status'));
        }
      } else {
        await post(`/asset/${assetId}/upload/failed`);
        reject(new Error('Error uploading file'));
      }
    };

    // Handle upload error
    xhr.onerror = () => {
      reject(new Error('Upload failed'));
    };

    // Send the file
    xhr.send(file);
  });
};
